import { loginUser } from "@/services/auth/login-user";
import { createServerFn } from "@tanstack/react-start";

import { setAuthCookies } from "@/lib/auth-cookies";
import { LoginPayload } from "@/types/auth";

export const loginUserServerFn = createServerFn({
  method: "POST",
})
  .inputValidator((data) => data as LoginPayload)
  .handler(async ({ data }) => {
    const res = await loginUser(data);

    setAuthCookies({
      accessToken: res.data.data.access_token,
      refreshToken: res.data.data.refresh_token,
    });

    return res.data.data.user;
  });
